/* RIXOKIN theme — interactions. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var stillPage = false;
  try { stillPage = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function animOn() { return !stillPage && document.body.classList.contains('rx-anim'); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  /* ---------- Reveal on scroll ---------- */
  var revealIO = null;
  function initReveal(root) {
    var els = $$('[data-reveal]', root);
    if (!animOn() || typeof IntersectionObserver === 'undefined') { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          revealIO.unobserve(en.target);
          en.target.classList.add('is-in');
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) {
      if (el.__rxReveal) return;
      el.__rxReveal = true;
      var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--rx-delay', (Math.min(i, 6) * 0.09) + 's');
      revealIO.observe(el);
    });
  }

  /* ---------- Interest checkboxes (sign-up) ---------- */
  function addInterests(list) {
    list.forEach(function (n) {
      $$('.rx-form input[name="rx-interest"][data-powder="' + n + '"]').forEach(function (cb) { cb.checked = true; });
    });
  }

  /* ---------- Header dropdown ---------- */
  function initNav(root) {
    $$('[data-rx-nav-toggle]', root).forEach(function (btn) {
      if (btn.__rx) return; btn.__rx = true;
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      function set(open) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); menu.classList.toggle('is-open', open); }
      btn.addEventListener('click', function (e) { e.stopPropagation(); set(btn.getAttribute('aria-expanded') !== 'true'); });
      document.addEventListener('click', function (e) { if (!menu.contains(e.target)) set(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
      $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    });
  }

  /* ---------- Powder walk ---------- */
  var walks = [];
  function initWalk(root) {
    $$('[data-rx-walk]', root).forEach(function (sec) {
      if (sec.__rx) return; sec.__rx = true;
      var worlds = $$('.rx-world', sec);
      var n = worlds.length;
      if (!n) return;
      var segBtns = $$('[data-rx-seg]', sec);
      var seg = $('.rx-seg', sec);
      var track = $('.rx-track', sec);
      var peekName = $('.rx-peek__name', sec);
      var peekBtn = $('.rx-peek button', sec);
      var prevBtn = $('[data-rx-prev]', sec);
      var nextBtn = $('[data-rx-next]', sec);
      var idx = 0;
      function go(i) {
        idx = (i + n) % n;
        var cur = worlds[idx], nxt = worlds[(idx + 1) % n], prv = worlds[(idx - 1 + n) % n];
        sec.style.setProperty('--walk-bg', cur.getAttribute('data-accent'));
        sec.style.setProperty('--peek-bg', nxt.getAttribute('data-accent'));
        if (track) track.style.setProperty('--i', idx);
        if (seg) { seg.style.setProperty('--i', idx); seg.style.setProperty('--ix', idx % 2); seg.style.setProperty('--iy', Math.floor(idx / 2)); }
        worlds.forEach(function (w, k) {
          var on = k === idx;
          w.classList.toggle('is-current', on);
          w.setAttribute('aria-hidden', on ? 'false' : 'true');
          if ('inert' in w) w.inert = !on;
        });
        segBtns.forEach(function (b, k) {
          b.setAttribute('aria-current', k === idx ? 'step' : 'false');
          if (k === idx) b.classList.add('is-visited');
        });
        if (peekName) peekName.textContent = nxt.getAttribute('data-name');
        if (peekBtn) peekBtn.setAttribute('aria-label', nxt.getAttribute('data-name'));
        if (nextBtn) nextBtn.setAttribute('aria-label', nxt.getAttribute('data-name'));
        if (prevBtn) prevBtn.setAttribute('aria-label', prv.getAttribute('data-name'));
        try { sec.dispatchEvent(new CustomEvent('rx:world-change', { detail: { index: idx } })); } catch (e) {}
        fit();
      }
      // Phones: the strip is only as tall as the powder on screen (no empty gap under shorter powders)
      var vpFit = $('.rx-viewport', sec), mqFit = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
      function fit() {
        if (!vpFit) return;
        if (mqFit && mqFit.matches) vpFit.style.height = worlds[idx].offsetHeight + 'px'; else vpFit.style.height = '';
      }
      if (typeof ResizeObserver !== 'undefined') { var roFit = new ResizeObserver(fit); worlds.forEach(function (w) { roFit.observe(w); }); }
      if (mqFit) { if (mqFit.addEventListener) mqFit.addEventListener('change', fit); else if (mqFit.addListener) mqFit.addListener(fit); }
      sec.__rxGo = go;
      segBtns.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
      if (peekBtn) peekBtn.addEventListener('click', function () { go(idx + 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });
      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
      $$('[data-rx-interest]', sec).forEach(function (a) {
        a.addEventListener('click', function () { addInterests(String(a.getAttribute('data-rx-interest')).split(',')); });
      });
      var vp = $('.rx-viewport', sec), tx = null;
      if (vp) {
        vp.addEventListener('touchstart', function (e) { tx = e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
        vp.addEventListener('touchend', function (e) {
          if (tx == null) return;
          var dx = (e.changedTouches[0] ? e.changedTouches[0].clientX : tx) - tx; tx = null;
          if (dx < -50) go(idx + 1); else if (dx > 50) go(idx - 1);
        }, { passive: true });
      }
      go(0);
      walks.push(sec);
      var nudge = $('.rx-viewport', sec);
      if (nudge && sec.hasAttribute('data-nudge') && animOn() && typeof IntersectionObserver !== 'undefined' && nudge.animate) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          nudge.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-7%)', offset: 0.4 }, { transform: 'translateX(1%)', offset: 0.75 }, { transform: 'translateX(0)' }], { duration: 1500, delay: 500, easing: 'cubic-bezier(.4,0,.2,1)' });
        }, { threshold: 0.3 });
        io.observe(nudge);
      }
    });
  }
  // Any element with data-rx-world="N" (powder number) opens that powder in the walk.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-rx-world]') : null;
    if (!t) return;
    var num = t.getAttribute('data-rx-world');
    walks.forEach(function (sec) {
      if (!document.body.contains(sec)) return;
      var worlds = $$('.rx-world', sec);
      for (var k = 0; k < worlds.length; k++) {
        if (worlds[k].getAttribute('data-powder') === num) { sec.__rxGo(k); break; }
      }
    });
  });

  /* ---------- Braid (scroll-linked) ---------- */
  function initBraid(root) {
    $$('[data-rx-braid]', root).forEach(function (zone) {
      if (zone.__rx) return; zone.__rx = true;
      var threads = $$('[data-thread]', zone), glints = $$('[data-glint]', zone);
      var knot = $('.rx-braid__knot', zone), ring = $('.rx-braid__ring', zone);
      if (!animOn() || zone.getAttribute('data-rx-braid') === 'static') {
        threads.forEach(function (el) { el.style.strokeDashoffset = '0'; });
        glints.forEach(function (el) { el.style.opacity = '0'; });
        return;
      }
      var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
      var popped = false, ticking = false;
      if (knot) knot.style.transform = 'scale(0)';
      function update() {
        ticking = false;
        if (!document.body.contains(zone)) { window.removeEventListener('scroll', onScroll); return; }
        var r = zone.getBoundingClientRect(), vh = window.innerHeight || 800;
        var p = clamp((vh - r.top) / (vh * 0.45 + r.height * 0.5));
        threads.forEach(function (el, i) { el.style.strokeDashoffset = String(1.02 - 1.02 * clamp((p - i * 0.05) / 0.65)); });
        glints.forEach(function (el, i) { el.style.strokeDashoffset = String(0.08 - 1.2 * clamp((p - 0.12 - i * 0.04) / 0.7)); });
        if (p >= 0.9 && !popped) {
          popped = true;
          if (knot && knot.animate) knot.animate([{ transform: 'scale(0) rotate(-120deg)' }, { transform: 'scale(1) rotate(0deg)' }], { duration: 560, easing: 'cubic-bezier(.34,1.8,.5,1)', fill: 'forwards' });
          else if (knot) knot.style.transform = 'none';
          if (ring && ring.animate) ring.animate([{ transform: 'scale(0.6)', opacity: 1 }, { transform: 'scale(2.8)', opacity: 0 }], { duration: 850, easing: 'cubic-bezier(.2,.7,.3,1)' });
        } else if (p < 0.6 && popped) {
          popped = false;
          if (knot) { if (knot.getAnimations) knot.getAnimations().forEach(function (a) { a.cancel(); }); knot.style.transform = 'scale(0)'; }
        }
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  /* ---------- Auto-advancing tabs (routine + how-to) ---------- */
  function autoplay(sec, bar, seconds, onDone) {
    if (!bar) return;
    if (!seconds || !animOn()) { bar.classList.remove('is-running'); return; }
    bar.style.setProperty('--dur', seconds + 's');
    bar.onanimationend = function (e) { if (e.target === bar) onDone(); };
    restart(bar, 'is-running');
  }

  function initRoutine(root) {
    $$('[data-rx-routine]', root).forEach(function (sec) {
      if (sec.__rx) return; sec.__rx = true;
      var parts = $$('.rx-daypart', sec);
      var btns = $$('[data-rx-daypart]', sec);
      var bar = $('.rx-progress i', sec);
      var hl = $('.rx-hl', sec);
      var secs = parseFloat(sec.getAttribute('data-autoplay') || '0');
      var cur = 0;
      function set(i, user) {
        cur = i;
        sec.classList.toggle('is-pm', i === 1);
        parts.forEach(function (p, k) { p.classList.toggle('is-current', k === i); p.setAttribute('aria-hidden', k === i ? 'false' : 'true'); if ('inert' in p) p.inert = k !== i; });
        btns.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        if (hl && animOn()) restart(hl, 'is-drawn');
        autoplay(sec, bar, user && secs ? secs * 1.6 : secs, function () { set(cur === 0 ? 1 : 0, false); });
      }
      btns.forEach(function (b, k) { b.addEventListener('click', function () { set(k, true); }); });
      $$('[data-rx-interest]', sec).forEach(function (a) {
        a.addEventListener('click', function () { addInterests(String(a.getAttribute('data-rx-interest')).split(',')); });
      });
      if (hl) hl.classList.add('is-drawn');
      // Start the timer only once the section is on screen.
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); set(cur, false); } }, { threshold: 0.25 });
        io.observe(sec);
      } else set(0, false);
    });
  }

  function initSteps(root) {
    $$('[data-rx-steps]', root).forEach(function (sec) {
      if (sec.__rx) return; sec.__rx = true;
      var steps = $$('.rx-step', sec);
      var imgs = $$('.rx-howto__frame > *', sec);
      var secs = parseFloat(sec.getAttribute('data-autoplay') || '0');
      var n = steps.length, cur = 0, started = false;
      if (!n) return;
      function set(i) {
        cur = i;
        sec.setAttribute('data-step', String(i));
        steps.forEach(function (s, k) {
          s.classList.toggle('is-current', k === i);
          s.classList.toggle('is-done', k < i);
          var b = $('button', s); if (b) b.setAttribute('aria-expanded', k === i ? 'true' : 'false');
          var line = $('.rx-step__line', s); if (line && k !== i) line.classList.remove('is-running');
        });
        imgs.forEach(function (im, k) { im.classList.toggle('is-current', k === i); if (im.tagName === 'IMG') im.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        if (started && !sec.__rxNoAuto) autoplay(sec, $('.rx-step__line', steps[i]), secs, function () { set((cur + 1) % n); });
      }
      steps.forEach(function (s, k) { var b = $('button', s); if (b) b.addEventListener('click', function () { started = true; set(k); }); });
      sec.__rxSet = function (i) { set(i); };
      sec.__rxCur = function () { return cur; };
      set(0);
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); started = true; set(cur); } }, { threshold: 0.25 });
        io.observe(sec);
      }
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    $$('[data-rx-faq]', root).forEach(function (sec) {
      if (sec.__rx) return; sec.__rx = true;
      var items = $$('.rx-faq__item', sec);
      items.forEach(function (it) {
        var b = $('.rx-faq__q', it), a = $('.rx-faq__a', it);
        b.addEventListener('click', function () {
          var open = !it.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            $('.rx-faq__q', o).setAttribute('aria-expanded', 'false');
            $('.rx-faq__a', o).setAttribute('aria-hidden', 'true');
          });
          if (open) { it.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); a.setAttribute('aria-hidden', 'false'); }
        });
      });
    });
  }

  /* ---------- Polaroids ---------- */
  function initPolaroids(root) {
    $$('.rx-polaroid', root).forEach(function (p) {
      if (p.__rx) return; p.__rx = true;
      p.addEventListener('click', function () {
        var on = !p.classList.contains('is-pinned');
        $$('.rx-polaroid.is-pinned').forEach(function (o) { o.classList.remove('is-pinned'); o.setAttribute('aria-pressed', 'false'); });
        p.classList.toggle('is-pinned', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  /* ---------- Sign-up form ---------- */
  function initForms(root) {
    $$('.rx-form', root).forEach(function (form) {
      if (form.__rx) return; form.__rx = true;
      var email = $('input[type="email"]', form);
      var err = $('.rx-form__error[data-client]', form);
      var tags = $('input[name="contact[tags]"]', form);
      var base = tags ? tags.getAttribute('data-base') || '' : '';
      var ok = $('.rx-success', form);
      if (ok && location.hash.indexOf('rx-signup-form') > -1) ok.focus();
      if (!email) return;
      email.addEventListener('input', function () { email.removeAttribute('aria-invalid'); if (err) err.hidden = true; });
      form.addEventListener('submit', function (e) {
        var v = (email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
          e.preventDefault();
          email.setAttribute('aria-invalid', 'true');
          if (err) err.hidden = false;
          email.focus();
          return;
        }
        if (tags) {
          var list = base ? base.split(',') : [];
          $$('input[name="rx-interest"]:checked', form).forEach(function (cb) { list.push(cb.value); });
          tags.value = list.map(function (s) { return s.trim(); }).filter(Boolean).join(', ');
        }
      });
    });
  }

  /* ---------- Sticky bar ---------- */
  function initSticky(root) {
    $$('[data-rx-sticky]', root).forEach(function (bar) {
      if (bar.__rx) return; bar.__rx = true;
      var hidden = {};
      var io = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(function (en) {
        en.forEach(function (x) { hidden[x.target.id || 'f'] = x.isIntersecting; });
        update();
      }) : null;
      if (io) $$('#signup, .rx-footer').forEach(function (el) { io.observe(el); });
      function update() {
        var over = Object.keys(hidden).some(function (k) { return hidden[k]; });
        bar.classList.toggle('is-visible', window.scrollY > 500 && !over);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ---------- Ingredient videos in the powder label (video mode) ---------- */
  function initLabelVideos(root) {
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    $$('video[data-rx-video]', root).forEach(function (video) {
      if (video.__rx) return; video.__rx = true;
      var world = video.closest('.rx-world');
      var walk = video.closest('[data-rx-walk]');
      var media = video.closest('.rx-label__media');
      var beatsList = media ? $('[data-rx-beats]', media) : null;
      var beats = beatsList ? $$('.rx-beat', beatsList) : [];
      var chip = media ? $('.rx-beat__chip', media) : null;
      if (!animOn()) { if (beatsList) beatsList.classList.add('is-static'); if (chip) chip.classList.add('is-static'); return; }
      if (beatsList) beatsList.classList.add('is-js');
      if (chip) chip.classList.add('is-js');
      var times = beats.map(function (b) { return parseFloat(b.getAttribute('data-at')) || 0; });
      var chipAt = chip ? (parseFloat(chip.getAttribute('data-at')) || 0) : 0;
      var active = -1, last = 0, visible = false, started = false, raf = null;
      function sync() {
        var t = video.currentTime || 0;
        if (t + 0.5 < last) active = -1; // looped back to the start
        last = t;
        var i = 0;
        for (var k = 0; k < times.length; k++) { if (times[k] <= t) i = k; }
        if (i !== active) { active = i; beats.forEach(function (b, k) { b.classList.toggle('is-active', k === i); }); }
        if (chip) chip.classList.toggle('is-active', t >= chipAt);
      }
      function tick() { sync(); raf = video.paused ? null : requestAnimationFrame(tick); }
      function current() { return !world || world.classList.contains('is-current'); }
      function update() {
        if (visible && current()) {
          if (!started) {
            started = true;
            var useMobile = mq && mq.matches;
            var src = (useMobile && video.getAttribute('data-src-mobile')) || video.getAttribute('data-src-desktop');
            if (src) video.src = src;
            video.preload = 'auto';
          }
          video.muted = true; video.autoplay = true;
          var pr = video.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      }
      video.addEventListener('timeupdate', sync);
      video.addEventListener('play', function () { if (!raf) raf = requestAnimationFrame(tick); });
      video.addEventListener('seeked', sync);
      sync();
      if (walk) walk.addEventListener('rx:world-change', update);
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(function (en) { visible = en[0].isIntersecting; update(); }, { threshold: 0.25 });
        io.observe(video);
      }
    });
    // Phone: label details open/close together for every powder in the walk, so switching powders keeps the same state
    $$('[data-rx-walk]', root).forEach(function (walk) {
      if (walk.__rxLabels) return; walk.__rxLabels = true;
      var labels = $$('.rx-label', walk);
      function set(open) {
        labels.forEach(function (l) {
          l.classList.toggle('is-open', open);
          var b = $('[data-rx-label-toggle]', l); if (!b) return;
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          var t = b.querySelector('span'); if (t) t.textContent = b.getAttribute(open ? 'data-close' : 'data-open');
        });
      }
      $$('[data-rx-label-toggle]', walk).forEach(function (b) {
        b.addEventListener('click', function () { set(!b.closest('.rx-label').classList.contains('is-open')); });
      });
      $$('.rx-scene__key', walk).forEach(function (a) { a.addEventListener('click', function () { set(true); }); });
    });
    // Feeding note "More" button (Highlights column)
    $$('.rx-more', root).forEach(function (btn) {
      if (btn.__rx) return; btn.__rx = true;
      var note = document.getElementById(btn.getAttribute('aria-controls'));
      if (!note) return;
      note.classList.add('is-clamped');
      function check() { if (!note.classList.contains('is-open')) btn.hidden = note.scrollHeight <= note.clientHeight + 1; }
      btn.addEventListener('click', function () {
        var open = !note.classList.contains('is-open');
        note.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(check).observe(note);
      check();
    });
  }

  /* ---------- Preload hidden slides (walk, steps, routine) before they scroll into view ---------- */
  function initPreload(root) {
    var zones = $$('[data-rx-walk], [data-rx-steps], [data-rx-routine]', root);
    function load(z) { $$('img[loading="lazy"]', z).forEach(function (im) { im.loading = 'eager'; }); }
    if (typeof IntersectionObserver === 'undefined') { zones.forEach(load); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { io.unobserve(x.target); load(x.target); } });
    }, { rootMargin: '800px 0px' });
    zones.forEach(function (z) { io.observe(z); });
  }


  /* ---------- PHONES ONLY (≤749px): M02 system carousel, M03 product bar, M05 scroll-linked steps, sticky bar spacing.
     Everything is set up only while the query matches and is fully torn down (listeners, timers, attributes,
     classes, inline styles, added elements) as soon as the viewport is wider than 749px. ---------- */
  var mqPhone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var phoneTeardowns = [];
  function phoneSystem(root) {
    var out = [];
    $$('.rx-system', root).forEach(function (sec) {
      var list = $('.rx-cards', sec); if (!list || list.__rxCar) return;
      var cards = $$('.rx-card', list), n = cards.length; if (n < 2) return;
      list.__rxCar = true;
      var h = $('h2', sec), label = h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
      var attrs = ['role', 'aria-roledescription', 'aria-label', 'aria-live'];
      var keep = attrs.map(function (a) { return list.getAttribute(a); });
      list.setAttribute('role', 'region'); list.setAttribute('aria-roledescription', 'carousel');
      if (label) list.setAttribute('aria-label', label);
      list.setAttribute('aria-live', 'off');
      cards.forEach(function (c, k) { c.setAttribute('role', 'group'); c.setAttribute('aria-roledescription', 'slide'); c.setAttribute('aria-label', (k + 1) + ' of ' + n); });
      var dots = document.createElement('div'); dots.className = 'rx-dots';
      var cur = 0, timer = null, resumeT = null, progT = null, inView = false, paused = false, focusHold = false, prog = false;
      var btns = cards.map(function (c, k) {
        var b = document.createElement('button'); b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (k + 1) + ' of ' + n);
        b.appendChild(document.createElement('i'));
        b.addEventListener('click', function () { hold(); go(k, true); });
        dots.appendChild(b); return b;
      });
      list.parentNode.insertBefore(dots, list.nextSibling);
      function pad() { return parseFloat(getComputedStyle(list).scrollPaddingLeft) || 0; }
      function target(k) { return list.scrollLeft + cards[k].getBoundingClientRect().left - list.getBoundingClientRect().left - pad(); }
      function mark(k) { btns.forEach(function (b, i) { b.setAttribute('aria-current', i === k ? 'true' : 'false'); }); }
      function go(k, user) {
        cur = (k + n) % n; prog = !user;
        clearTimeout(progT); progT = setTimeout(function () { prog = false; }, 900);
        list.scrollTo({ left: target(cur), behavior: animOn() ? 'smooth' : 'auto' });
        mark(cur);
      }
      function nearest() {
        var lr = list.getBoundingClientRect().left + pad(), best = 0, bd = 1e9;
        cards.forEach(function (c, i) { var d = Math.abs(c.getBoundingClientRect().left - lr); if (d < bd) { bd = d; best = i; } });
        return best;
      }
      function canRun() { return animOn() && inView && !paused && !focusHold && !document.hidden; }
      function schedule() { clearInterval(timer); timer = null; if (canRun()) timer = setInterval(function () { go(cur + 1, false); }, 4000); }
      function hold() { paused = true; schedule(); clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; schedule(); }, 6000); }
      var lastGesture = 0;
      function gesture() { lastGesture = Date.now(); hold(); }
      function onScroll() { cur = nearest(); mark(cur); if (!prog && Date.now() - lastGesture < 2500) hold(); }
      function onFocusIn() { focusHold = true; schedule(); }
      function onFocusOut(e) { if (!sec.contains(e.relatedTarget)) { focusHold = false; hold(); } }
      var io = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(function (en) { inView = en[0].intersectionRatio >= 0.5; schedule(); }, { threshold: [0, 0.5, 1] }) : null;
      if (io) io.observe(list);
      var evs = ['touchstart', 'pointerdown', 'wheel'];
      evs.forEach(function (e) { list.addEventListener(e, gesture, { passive: true }); dots.addEventListener(e, gesture, { passive: true }); });
      list.addEventListener('scroll', onScroll, { passive: true });
      sec.addEventListener('focusin', onFocusIn); sec.addEventListener('focusout', onFocusOut);
      document.addEventListener('visibilitychange', schedule);
      mark(0);
      out.push(function () {
        clearInterval(timer); clearTimeout(resumeT); clearTimeout(progT);
        if (io) io.disconnect();
        evs.forEach(function (e) { list.removeEventListener(e, gesture); });
        list.removeEventListener('scroll', onScroll);
        sec.removeEventListener('focusin', onFocusIn); sec.removeEventListener('focusout', onFocusOut);
        document.removeEventListener('visibilitychange', schedule);
        if (dots.parentNode) dots.parentNode.removeChild(dots);
        attrs.forEach(function (a, i) { if (keep[i] == null) list.removeAttribute(a); else list.setAttribute(a, keep[i]); });
        cards.forEach(function (c) { c.removeAttribute('role'); c.removeAttribute('aria-roledescription'); c.removeAttribute('aria-label'); });
        list.scrollLeft = 0; list.__rxCar = false;
      });
    });
    return out;
  }
  function phoneWalk(root) {
    var out = [];
    $$('[data-rx-walk]', root).forEach(function (sec) {
      if (sec.__rxPhone) return; sec.__rxPhone = true;
      var segBtns = $$('[data-rx-seg]', sec), row = $('.rx-seg-row', sec), stage = $('.rx-stage', sec);
      function sync() {
        var w = $('.rx-world.is-current', sec);
        if (w) { var t = getComputedStyle(w).getPropertyValue('--tint').trim(); if (t) sec.style.setProperty('--rx-cur-tint', t); }
        segBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('aria-current') === 'step' ? 'true' : 'false'); });
      }
      // A tab tapped while reading further down the panel: glide to the top of the new product, just under the bar.
      function onTab() {
        setTimeout(function () {
          if (!row || !stage) return;
          var gap = stage.getBoundingClientRect().top - (row.getBoundingClientRect().bottom + 8);
          if (gap < -1) window.scrollBy({ top: gap, behavior: animOn() ? 'smooth' : 'auto' });
        }, 0);
      }
      sec.addEventListener('rx:world-change', sync);
      segBtns.forEach(function (b) { b.addEventListener('click', onTab); });
      sync();
      out.push(function () {
        sec.removeEventListener('rx:world-change', sync);
        segBtns.forEach(function (b) { b.removeEventListener('click', onTab); b.removeAttribute('aria-pressed'); });
        sec.style.removeProperty('--rx-cur-tint'); sec.__rxPhone = false;
      });
    });
    return out;
  }
  function phoneSteps(root) {
    var out = [];
    $$('[data-rx-steps]', root).forEach(function (sec) {
      if (!sec.__rxSet || sec.__rxLinked) return; sec.__rxLinked = true;
      var steps = $$('.rx-step', sec);
      sec.__rxNoAuto = true;
      $$('.rx-step__line', sec).forEach(function (l) { l.classList.remove('is-running'); });
      sec.classList.add('is-linked');
      sec.style.setProperty('--rx-howto-bg', getComputedStyle(sec).backgroundColor);
      // The step whose text crosses the reading band (below the sticky frame) becomes current; frame and line follow via set(i).
      var io = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { var k = steps.indexOf(e.target); if (k > -1) sec.__rxSet(k); } });
      }, { rootMargin: '-62% 0px -30% 0px' }) : null;
      if (io) steps.forEach(function (st) { io.observe(st); });
      out.push(function () {
        if (io) io.disconnect();
        sec.classList.remove('is-linked'); sec.style.removeProperty('--rx-howto-bg');
        sec.__rxNoAuto = false; sec.__rxLinked = false;
        sec.__rxSet(sec.__rxCur());
      });
    });
    return out;
  }
  function phoneSticky(root) {
    var out = [];
    $$('[data-rx-sticky]', root).forEach(function (bar) {
      var html = document.documentElement;
      function refresh() { html.classList.toggle('rx-sticky-on', bar.classList.contains('is-visible') && !bar.classList.contains('is-suppressed')); }
      function isField(t) { return t && t.matches && t.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, select'); }
      function fin(e) { if (isField(e.target)) { bar.classList.add('is-suppressed'); refresh(); } }
      function fout(e) { if (isField(e.target)) { bar.classList.remove('is-suppressed'); refresh(); } }
      var mo = typeof MutationObserver !== 'undefined' ? new MutationObserver(refresh) : null;
      if (mo) mo.observe(bar, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('focusin', fin); document.addEventListener('focusout', fout);
      refresh();
      out.push(function () {
        if (mo) mo.disconnect();
        document.removeEventListener('focusin', fin); document.removeEventListener('focusout', fout);
        bar.classList.remove('is-suppressed'); html.classList.remove('rx-sticky-on');
      });
    });
    return out;
  }
  function phoneApply() {
    phoneTeardowns.forEach(function (t) { try { t(); } catch (e) {} });
    phoneTeardowns = [];
    if (!mqPhone || !mqPhone.matches) return;
    phoneTeardowns = [].concat(phoneSystem(document), phoneWalk(document), phoneSteps(document), phoneSticky(document));
  }
  if (mqPhone) { if (mqPhone.addEventListener) mqPhone.addEventListener('change', phoneApply); else if (mqPhone.addListener) mqPhone.addListener(phoneApply); }

  function init(root) {
    initPreload(root); initNav(root); initWalk(root); initLabelVideos(root); initBraid(root); initRoutine(root); initSteps(root);
    initFaq(root); initPolaroids(root); initForms(root); initSticky(root); initReveal(root);
    phoneApply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor: re-run when a section is added, changed or re-ordered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var w = e.target.closest && e.target.closest('[data-rx-walk]');
    if (w && w.__rxGo) { var all = $$('.rx-world', w); var k = all.indexOf(e.target); if (k > -1) w.__rxGo(k); }
  });
})();
